import { css } from '@emotion/css';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BestFriendProfileErrorType } from '../../../features/bestFriends';

export const ProfileErrorText: React.FC<{ profileErrorType?: BestFriendProfileErrorType }> = ({
  profileErrorType
}) => {
  const { t } = useTranslation('translation');
  const errorText = getText(t, profileErrorType);

  return (
    <>
      {profileErrorType && (
        <div
          className={css`
            font-size: 12px;
            text-align: center;
            margin: 12px 0 20px;
            .error {
              color: #e60012;
            }
          `}
        >
          <p className="error">{errorText}</p>
        </div>
      )}
    </>
  );
};

// helper function
function getText(t: TFunction, errorType?: BestFriendProfileErrorType) {
  switch (errorType) {
    case 'unstable-network':
      return t('error_unstable_network');
    case 'unknown':
    default:
      return t('error_unknown');
  }
}
